// Интендант (deus_intendant, rare) — order при размещении.
// База: +1 карта из колоды в руку, +1 extraPlaysNextTurn.
// При Влияние >= 10: +2 карты в руку, вторая (последняя взятая) сразу в низ колоды,
// в руке остаётся 1 новая карта; +1 extraPlaysNextTurn.
//
// Упрощение А.4.4.4: «сыграй сразу» → «extra play next turn». Юзер согласен.

export const CARD_ID = 'deus_intendant';

export function intendantOrder(state, ownerIdx) {
  const p = state.players[ownerIdx];
  if (p.influence >= 10) {
    // +2 карты, вторую в низ колоды.
    const a = p.drawOne();
    const b = p.drawOne();
    if (a) {
      if (p.hand.length >= 10) {
        p.discard.push(a);
        state.log.add(`📦 Интендант [${p.name}]: рука полна, "${a.name_ru}" сгорает`);
      } else {
        p.hand.push(a);
        state.log.add(`📦 Интендант [${p.name}]: +1 карта в руку (Влияние 10) — "${a.name_ru}"`);
      }
    }
    if (b) {
      p.deck.push(b);                     // в низ колоды
      state.log.add(`📦 Интендант [${p.name}]: вторая карта "${b.name_ru}" — в низ колоды`);
    }
  } else {
    const a = p.drawOne();
    if (a) {
      if (p.hand.length >= 10) {
        p.discard.push(a);
        state.log.add(`📦 Интендант [${p.name}]: рука полна, "${a.name_ru}" сгорает`);
      } else {
        p.hand.push(a);
        state.log.add(`📦 Интендант [${p.name}]: +1 карта из колоды`);
      }
    } else {
      state.log.add(`📦 Интендант [${p.name}]: колода пуста`);
    }
  }
  p.extraPlaysNextTurn = (p.extraPlaysNextTurn || 0) + 1;
  state.log.add(`📦 Интендант [${p.name}]: +1 размещение в следующий Ф2`);
}
